import styled from 'styled-components';
import { getTextPresetCss } from '@optimus-web/common';
import { SPACING, TEXT_PRESET_KEY } from '@optimus-web/local-tokens';
import { Icon } from '../Icon';
import { getTypographyColorToken } from '../typography';

export const IconListItem = styled.li`
    display: flex;
    align-items: center;
`;

export const IconListItemIcon = styled(Icon)`
    margin-right: ${SPACING[200]}px;
`;

interface IconListItemLabelProps {
    small?: boolean;
}

export const IconListItemLabel = styled.div<IconListItemLabelProps>`
    word-break: break-word;
    ${(props) => getTextPresetCss(TEXT_PRESET_KEY[props.small ? '200m' : '300m'])}
    color: ${getTypographyColorToken()};
`;

interface IconListItemDescriptionProps {
    small?: boolean;
}

export const IconListItemDescription = styled.div<IconListItemDescriptionProps>`
    word-break: break-word;
    ${(props) => getTextPresetCss(TEXT_PRESET_KEY[props.small ? '100r' : '200r'])}
    color: ${getTypographyColorToken({ variant: 'secondary' })};
`;
